import { Button } from "antd";
import React from "react";

function BuyCoinItem({ status, data, onClick }) {
  return (
    <div className='buy-more-icon-item'>
      <div className='buy-more-icon-item__content-group'>
        <img src={data?.image} alt='' className='buy-more-icon-item__image' />
        <div className='buy-more-icon-item__content'>
          <p className='package-name'>{data?.packageName}</p>
          <p className='package-value'>{data?.packageValue}</p>
          <p className={`valid-time ${status === 1 ? "valid-time-cancel" : ""}`}>{data?.validTime}</p>
        </div>
      </div>
      <Button
        className={`buy-more-icon-item__btn ${
          status === 1 ? "btn-cancel" : ""
        }`}
        onClick={onClick}
      >
        {status === 1 ? "Cancel" : "Buy"}
      </Button>
    </div>
  );
}

export default BuyCoinItem;
